/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Lernfoerderungaufenthalt1Inputs */

const de__field_lernfoerderungaufenthalt1 = /** @type {(inputs: _Field_Lernfoerderungaufenthalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LeFö Aufenthalt`)
};

/**

* @param {_Field_Lernfoerderungaufenthalt1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_lernfoerderungaufenthalt1 = /** @type {((inputs?: _Field_Lernfoerderungaufenthalt1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Lernfoerderungaufenthalt1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_lernfoerderungaufenthalt1(inputs)
});
export { _field_lernfoerderungaufenthalt1 as "_field_lernfoerderungAufenthalt" }